// eslint-disable-next-line no-unused-vars
import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";
import { defineMessages, injectIntl } from "react-intl";
import { withStyles } from "@material-ui/core";
import { Link } from "react-router-dom";

import { VehicleSingleRegistrySyncHistoryPageBase } from "../../admin/VehicleSingleRegistrySyncHistoryPage/VehicleSingleRegistrySyncHistoryPage";
import HUBContext from "../../../../services/HUBContext";
import { ROUTER_MAP_PATH } from "../../../../EmbeddedRoutes";
import { DV3SearchIcon } from "../../../../common/icons";
import { Input, Table } from "antd";
import { styles } from "./VehicleSingleRegistrySyncHistoryWidget.styles";
import { translations } from "./constants";
import CustomPaginatorWidget from "../CustomPaginatorWidget/CustomPaginatorWidget";

const messages = defineMessages(translations);
const defaultPageSize = 5;

export class VehicleSingleRegistrySyncHistoryWidget extends VehicleSingleRegistrySyncHistoryPageBase {
  getBackURL() {
    return ROUTER_MAP_PATH.vehicles.homePage.replace(
      ":cid",
      this.context?.company?.companyID,
    );
  }

  getDefaultPageSize() {
    return defaultPageSize;
  }

  render() {
    const { intl, classes } = this.props;
    const { search, response } = this.state;

    return (
      <div className={classes.page}>
        <div className={classes.cardHeader}>
          <span className={classes.subtitleText}>
            {intl.formatMessage(messages.subtitle)}
          </span>
        </div>

        <div className={classes.pageContent}>
          <div className={`filters-area ${classes.filtersArea}`}>
            <div className={`filters-area-search ${classes.filtersSearch}`}>
              <Input
                value={search}
                onChange={this.handleSearchChange}
                onPressEnter={this.onSearchEnter}
                placeholder={intl.formatMessage(messages.searchPlaceholder)}
                addonAfter={<DV3SearchIcon onClick={this.handleSearchSubmit} />}
              />
            </div>
          </div>
          <div className={`table-area ${classes.tableArea}`}>
            <Table
              pagination={false}
              scroll={{ x: true }}
              dataSource={
                Array.isArray(response)
                  ? response
                  : response?.data || response?.items || []
              }
              columns={this.columns(intl).filter((x) => !!x)}
              onChange={this.onTableChange}
              rowKey={(record, index) => index}
            />

            <CustomPaginatorWidget
              pagerInfo={response}
              onChange={(current) =>
                this.getData(
                  response?.pageSize || this.getDefaultPageSize(),
                  (current > 0 ? current - 1 : 0) *
                    (response?.pageSize || this.getDefaultPageSize()),
                  response?.sortProperty,
                  response?.sortDirection || "asc",
                  response?.search,
                )
              }
              onShowSizeChange={(current, size) =>
                this.getData(
                  size,
                  (current > 0 ? current - 1 : 0) * size,
                  response?.sortProperty,
                  response?.sortDirection || "asc",
                  response?.search,
                )
              }
            />
          </div>

          <div className={classes.backContent}>
            <hr className={classes.divider} />

            <div className={classes.backLink}>
              <Link className="v3-button" to={this.getBackURL()}>
                <span>{intl.formatMessage(messages.goBack)}</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

VehicleSingleRegistrySyncHistoryWidget.contextType = HUBContext;
VehicleSingleRegistrySyncHistoryWidget = withRouter(
  injectIntl(VehicleSingleRegistrySyncHistoryWidget),
);
VehicleSingleRegistrySyncHistoryWidget = withStyles(styles)(
  VehicleSingleRegistrySyncHistoryWidget,
);

export default VehicleSingleRegistrySyncHistoryWidget;
